var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgSquaresOverlapping(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M18.368 7c1.047 0 1.895.848 1.895 1.895v2.841h2.842c.997 0 1.814.77 1.89 1.748l.005.148v9.473A1.895 1.895 0 0123.105 25h-9.473a1.895 1.895 0 01-1.895-1.895l-.001-2.842H8.895c-.997 0-1.814-.77-1.89-1.747L7 18.368V8.895C7 7.848 7.848 7 8.895 7zm4.737 5.684h-2.842v5.684c0 .997-.77 1.814-1.747 1.89l-.148.005h-5.684v2.842c0 .486.366.887.837.941l.11.007h9.474a.947.947 0 00.948-.948v-9.473a.947.947 0 00-.948-.948zm-4.737-4.737H8.895a.947.947 0 00-.948.948v9.473c0 .524.425.948.948.948l2.841-.001v-5.683c0-.997.77-1.814 1.748-1.89l.148-.005 5.683-.001V8.895a.948.948 0 00-.836-.941l-.11-.007z"
  }));
}

export default SvgSquaresOverlapping;